// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "email": {
      "column": {
        "default": null,
        "name": "email",
        "null": false,
        "type": "string"
      },
      "name": "email",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ContactMergeRequest",
  "collectionKey": "contact_merge_requests",
  "collectionName": "contact_merge_requests",
  "i18nKey": "contact_merge_request",
  "camelizedLower": "contactMergeRequest",
  "name": "ContactMergeRequest",
  "nameDasherized": "contact-merge-request",
  "pluralName": "contact_merge_requests",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "source_contact_id",
      "name": "source_contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "target_contact_id",
      "name": "target_contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "email",
      "column": {
        "default": null,
        "name": "email",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "source_contact_id",
      "column": {
        "default": null,
        "name": "source_contact_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "target_contact_id",
      "column": {
        "default": null,
        "name": "target_contact_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "token",
      "column": {
        "default": null,
        "name": "token",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "token_generated_at",
      "column": {
        "default": null,
        "name": "token_generated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [],
  "paramKey": "contact_merge_request",
  "primaryKey": "id"
}

/** Frontend model for ContactMergeRequest. */
export default class ContactMergeRequest extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  email() {
    return this.readAttributeUnderscore("email")
  }

  /** @returns {boolean} */
  hasEmail() {
    const value = this.email()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static createFromEmail(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "create_from_email",
        collectionName: "contact_merge_requests",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  confirmMerge(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "confirm_merge",
        primaryKey: this.primaryKey(),
        collectionName: "contact_merge_requests",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  resendEmail(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "resend_email",
        primaryKey: this.primaryKey(),
        collectionName: "contact_merge_requests",
        type: "member"
      },
      commandArgs
    ))
  }
}
